var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentFormat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 18.3346H15C15.4421 18.3346 15.866 18.159 16.1786 17.8465C16.4911 17.5339 16.6667 17.11 16.6667 16.668V5.83464L12.5 1.66797H5.00004C4.55801 1.66797 4.13409 1.84356 3.82153 2.15612C3.50897 2.46868 3.33337 2.89261 3.33337 3.33464V6.66797",
    stroke: "#67768E",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1.66797V5.0013C11.6666 5.44333 11.8422 5.86725 12.1548 6.17981C12.4673 6.49237 12.8913 6.66797 13.3333 6.66797H16.6666",
    stroke: "#67768E",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99996 11.6667C4.99996 10.7462 4.25377 10 3.33329 10C2.41282 10 1.66663 10.7462 1.66663 11.6667V13.3333C1.66663 14.2538 2.41282 15 3.33329 15C4.25377 15 4.99996 14.2538 4.99996 13.3333V11.6667Z",
    stroke: "#67768E",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 10H10V15",
    stroke: "#67768E",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 15H11.6667",
    stroke: "#67768E",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFormat);
export default __webpack_public_path__ + "static/media/DocumentFormat.8c4528d2b488da4cbcdf34e523fa773a.svg";
export { ForwardRef as ReactComponent };